var map = {
	"./bell.svg": 85846,
	"./docError.svg": 2125,
	"./gear.svg": 54540,
	"./help-Filled.svg": 35605,
	"./help-Outline.svg": 16521,
	"./redBell.svg": 95813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36507;